module.exports = __webpack_public_path__ + "0bd13b604180462de5c6583520756bcf.png";


//////////////////
// WEBPACK FOOTER
// ./application/adminlte/plugins/iCheck/minimal/yellow.png
// module id = 317
// module chunks = 0